import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col, Spin, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getAllPackagesByResellerId } from '../../redux/slices/packageSlice';
import { AppDispatch, RootState } from '../../redux/store';

export function PosPackages() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { packages, loading } = useSelector((state: RootState) => state.packages);
  const { user } = useSelector((state: RootState) => state.auth);
  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(getAllPackagesByResellerId());
  }, [dispatch]);

  const handleCardClick = (packageId: number) => {
    navigate(`/package/${packageId}`);
  };

  const filteredPackages = packages.filter(pkg =>
    pkg.prepaidPackageTemplateName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ padding: 24 }}>
      {loading ? (
        <div style={{ textAlign: 'center', marginTop: 100 }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          <Input
            placeholder="Search packages..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ marginBottom: 24 }}
            size="large"
          />
          <Row gutter={[24, 24]}>
            {filteredPackages.length > 0 ? (
              filteredPackages.map(pkg => (
                <Col key={pkg.id} xs={24} sm={12} md={8} lg={6}>
                  <Card
                    hoverable
                    onClick={() => handleCardClick(pkg.id)}
                    style={{ borderRadius: 10, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                    bodyStyle={{ textAlign: 'center', padding: 24 }}
                  >
                    <h3 style={{ marginBottom: 12 }}>{pkg.prepaidPackageTemplateName}</h3>
                    {user?.showPrices && (
                      <p style={{ marginBottom: 8, fontSize: 16 }}><strong>{(pkg.dataByte / (1024 * 1024)).toFixed(0)} MB</strong></p>
                    )}
                    <p style={{ marginBottom: 8 }}>{pkg.periodDays} Days</p>
                    {user?.showPrices && (
                      <p style={{ fontWeight: 'bold', color: '#1890ff', fontSize: 18 }}>{pkg.cost}€</p>
                    )}
                  </Card>
                </Col>
              ))
            ) : (
              <div style={{ width: '100%', textAlign: 'center', padding: '50px 0', fontSize: 18 }}>
                No packages found.
              </div>
            )}
          </Row>
        </>
      )}
    </div>
  );
}

export default PosPackages;
